import { Component } from '@angular/core';
// import { Component, ViewContainerRef } from '@angular/core';
// import moment from 'moment';
// import { CpxHandleServiceAbstract } from './services/cpx-handle/cpx-handle-service-abstract';
// import { DmpServiceAbstract } from './services/dmp/dmp-service.abstract';
// import { InsRealservice } from './services/ins/ins.service';
// import { ModalService } from './services/modal/modal.service';

// Liste d'assets à pré-charger afin d'éviter des lenteurs d'affichage par la suite
const ASSETS_TO_PRELOAD = [
  '/assets/icons/green-checkmark.svg'
];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'hypermed-front';

  // private _resourceId: string;

  constructor(
    // private _insiSrv: InsRealservice,
    // private _cpxHandleSrv: CpxHandleServiceAbstract,
    // private _dmpSrv: DmpServiceAbstract,
    // private _view: ViewContainerRef,
    // private _modalSrv: ModalService
  ) {
    this._preloadAssets();
    this._retrieveAndStoreToken();

    // const currentProfilStr = localStorage.getItem('currentProfil');
    // if (currentProfilStr && currentProfilStr !== '') {
    //   const currentProfil = JSON.parse(currentProfilStr);
    //   this._resourceId = currentProfil.id;
    //   this._dmpSrv.resourceId = this._resourceId;
    //   this._insiSrv.resourceId = this._resourceId;
    // }
  }

  private _retrieveAndStoreToken(): void {
    if (typeof window !== 'undefined' && window.location) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (token) {
          sessionStorage.setItem('renew_password_token', token);
        }
      } catch (e) {
        console.error('Error retrieving token from URL:', e);
      }
    }
  }

  private _preloadAssets(): void {
    if (ASSETS_TO_PRELOAD && ASSETS_TO_PRELOAD.length > 0) {
      for (const atp of ASSETS_TO_PRELOAD) {
        const image = new Image();
        image.src = atp;
      }
    }
  }

  // public async rechercheInsi(): Promise<void> {
  //   console.log('rechercheInsi !');
  //   const loading = this._modalSrv.openLoading(this._view);
  //   try {
  //     const res = await this._insiSrv.getInsFromIdentityInformation(this._view, {
  //       i_sex: undefined,
  //       s_birthDate: '1977-07-14',
  //       s_birthName: 'DE VINCI',
  //       s_birthPlace: '',
  //       s_given: 'RUTH'
  //     });
  //     console.log('getInsFromIdentityInformation - res : ', res);
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     loading.destroy();
  //   }
  // }

  // public async getInsiFromVitale(): Promise<void> {
  //   console.log('getInsiFromVitale !');
  //   const loading = this._modalSrv.openLoading(this._view);
  //   try {
  //     const res = await this._cpxHandleSrv.lectureVitale(this._view);
  //     console.log('getInsiFromVitale - res : ', res);
  //     const ins = await this._cpxHandleSrv.getInsFromVitale(this._view, this._resourceId, 0);
  //     console.log('getInsiFromVitale - ins : ', ins);
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     loading.destroy();
  //   }
  // }

  // public async rechercheDmp(): Promise<void> {
  //   console.log('rechercheDmp !');
  //   const loading = this._modalSrv.openLoading(this._view);
  //   try {
  //     const res = await this._dmpSrv.hl_findpatient(this._view, {
  //       i_approxCity: undefined,
  //       i_approxName: undefined,
  //       i_sex: 3,
  //       s_birthday: moment('15-06-1955', 'DD-MM-YYYY').toDate(),
  //       s_city: undefined,
  //       s_givenName: 'Nathalie',
  //       s_name: 'DESMAUX',
  //       s_postalCode: undefined
  //     });
  //     console.log('rechercheDmp - res : ', res);
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     loading.destroy();
  //   }
  // }
}
